/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { Stack, Typography, FormControl, Select, MenuItem, Pagination } from "@mui/material";

const PaginationFooter = (props) => {
    
    const {
        page,
        pageSize,
        pages,
        firstPos,
        lastPos,
        total,
        handlePageSizeChange,
        selectPage
    } = props;
    
    const rowsMessage = (firstPos && lastPos)?`${firstPos}-${lastPos}`:"";
    const countMessage = total?` of ${total}`:"";

    return (
        <Fragment>
            <Stack direction='row'>
                <Typography style={{ margin: "0.8rem", lineHeight: "1.5rem" }}>
                    Rows per page:
                </Typography>
                <FormControl sx={{ m: 1, minWidth: 120 }} size='small'>
                    <Select
                        id='demo-select-small'
                        value={pageSize}
                        onChange={handlePageSizeChange}
                        style={{ backgroundColor: "#FFFFFF" }}
                    >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={40}>40</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                        <MenuItem value={200}>200</MenuItem>
                    </Select>
                </FormControl>
                <Typography style={{ margin: "0.8rem", lineHeight: "1.5rem" }}>
                    {rowsMessage}
                    {countMessage}
                </Typography>
                <Typography style={{ margin: "0.8rem", lineHeight: "1.5rem" }}>Page:</Typography>
                <Pagination
                    style={{ margin: "0.6rem", backgroundColor: "#FFFFFF" }}
                    page={page}
                    count={pages}
                    variant='outlined'
                    shape='rounded'
                    onChange={selectPage}
                />
            </Stack>
        </Fragment>
    );
};

export default PaginationFooter;
